<template>
  <div class="header-container">
    <div class="header">
      <img class="logo" @click="toHome" src="../assets/logo.png?v20260623">
      <div class="right">
        {{greetings}}，<span @click="toInformation">{{userinfo.name}}</span><label @click="toInformation">老师</label>
        <a class="logout" @click="logout()">退出登录</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  props: {
    userinfo: Object
  },
  data () {
    return {
      greetings: '你好'
    }
  },
  mounted () {
    let time = new Date()
    let h = time.getHours()
    if (h > 5 && h <= 9) {
      this.greetings = '早上好'
    } else if (h > 9 && h <= 12) {
      this.greetings = '上午好'
    } else if (h > 12 && h <= 19) {
      this.greetings = '下午好'
    } else {
      this.greetings = '晚上好'
    }
  },
  methods: {
    // 个人详情页
    toInformation () {
      this.$router.push({ name: 'information' })
    },
    // 登出
    logout () {
      if (window.localStorage) {
        window.localStorage.clear()
      }
      if (window.sessionStorage) {
        window.sessionStorage.clear()
      }
      location.hash = '/'
      this.$message({
        type: 'success',
        message: '退出成功!'
      })
    },
    // 首页
    toHome () {
      this.$router.push({ name: 'panel' })
    }
  }
}
</script>
<style>
.header-container {
  width: 100%;
  height: 100px;
  background: #fff;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 960px;
  margin: 0 auto;
  height: 100px;
}
.header .logo {
  width: 359px;
  height: 60px;
  cursor: pointer;
}
.header .right {
  margin-top: 7px;
}
.header .right .logout {
  margin-left: 20px;
  color: #FE793A;
  cursor: pointer;
}
.header .right span {
  color: #FE793A;
  cursor: pointer;
}
</style>
